<template>
  <div class="app-container">
    <div class="header">{{ reseller.first_name }}</div>
    <nav class="add-navigation flex-wrap">
      <div
        @click="$router.push({ name: 'system-admin-resellers' })"
        class="back-link  mr-3"
      >
        <svg
          class="icon"
          width="30px"
          height="30px"
          viewBox="0 0 30 30"
          version="1.1"
        >
          <path
            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
            id="path-1"
          />
        </svg>
        <p style="white-space: nowrap">Back to Resellers</p>
      </div>
      <div class="buttons-wrapper flex-wrap flex ">
        <div
          @click="$router.push({ name: 'system-admin-resellers' })"
          class="secondary-button button-margin-size  button_size"
        >
          <secondary-button class="button_size">Cancel</secondary-button>
        </div>
        <div class="primary-button button-margin-size">
          <primary-button @click.native="editReseller"
            >Save Reseller</primary-button
          >
        </div>
      </div>
    </nav>
    <div v-if="!loading" class="add-container py-3">
      <span class="container-title d-block px-3 mb-4">Edit Reseller Information</span>
      <div class="row px-3">
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="first name"
                  class="field row-first"
                  :value="reseller.first_name"
                  @input="handleFirstName"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('first name') }"
                  placeholder="Enter first name"
          />
          <div class="help is-danger" v-if="errors.has('first name')">
            {{ errors.first("first name") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="last name"
                  class="row-first"
                  :value="reseller.last_name"
                  @input="handleLastName"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('last name') }"
                  placeholder="Enter last name"
          />
          <div class="help is-danger" v-if="errors.has('last name')">
            {{ errors.first("last name") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="number"
                  name="phone"
                  class="field row-second last"
                  v-model="reseller.contact.phone"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('phone') }"
                  placeholder="Enter phone"
          />
          <div class="help is-danger" v-if="errors.has('phone')">
            {{ errors.first("phone") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="email"
                  class="row-second"
                  v-model="reseller.contact.email"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('email') }"
                  placeholder="Enter email"
          />
          <div class="help is-danger" v-if="errors.has('email')">
            {{ errors.first("email") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="password"
                  class="row-first"
                  v-model="reseller.contact.passwd"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('password') }"
                  placeholder="Enter password"
          />
          <div v-if="errors.has('password')" class="help is-danger">
            {{ errors.first("password") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="address"
                  class="field row-address"
                  v-model="reseller.contact.address"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('address') }"
                  placeholder="Enter address"
          />
          <div class="help is-danger" v-if="errors.has('address')">
            {{ errors.first("address") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="zipcode"
                  class="row-zipcode last"
                  v-model="reseller.contact.zipcode"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('zipcode') }"
                  placeholder="Enter zip code"
          />
          <div class="help is-danger" v-if="errors.has('zipcode')">
            {{ errors.first("zipcode") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-select
                  type="text"
                  name="country"
                  class="row-country"
                  v-validate="'required'"
                  v-model="reseller.contact.country_uuid"
                  :class="{ input: true, 'is-danger': errors.has('country') }"
                  placeholder="country"
          >
            <option
                    :value="i.country_uuid"
                    v-for="(i, country_uuid) in countrys"
                    :key="country_uuid"
            >
              {{ i.nice_name ? i.nice_name : i.name }}
            </option>
          </primary-select>
          <div class="help is-danger" v-if="errors.has('country')">
            {{ errors.first("country") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="state"
                  class="field row-third"
                  v-model="reseller.contact.state"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('state') }"
                  placeholder="State"
          />
          <div class="help is-danger" v-if="errors.has('state')">
            {{ errors.first("state") }}
          </div>
        </div>
        <div class="col-md-6 col-12 mb-3">
          <primary-input
                  type="text"
                  name="city"
                  class="field row-third last"
                  v-model="reseller.contact.city"
                  v-validate="'required'"
                  :class="{ input: true, 'is-danger': errors.has('city') }"
                  placeholder="Enter city"
          />
          <div class="help is-danger" v-if="errors.has('city')">
            {{ errors.first("city") }}
          </div>
        </div>
            <!-- <div class="list primary-input-container multiselect row-second">
              <p class="pimary-input-title">Company</p>
              <multiselect
                v-model="reseller.companies"
                :options="allcompanies"
                :value="allcompanies"
                :multiple="true"
                :close-on-select="false"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Pick Company"
                label="name"
                track-by="company_uuid"
                :preselect-first="true"
              >
                <template slot="selection" slot-scope="{ values, search, isOpen, option }">
                  <span
                    class="multiselect__single"
                    v-if="values.length &amp;&amp; !isOpen"
                  >{{ values.length }} selected</span>
                </template>
              </multiselect>
            </div>
            <div class="help is-danger" v-if="errors.has('company')">{{ errors.first('company') }}</div>-->

      </div>
    </div>
    <loader :loading="loading" v-if="loading"/>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    EditDropzone: () => import("@/components/EditDropzone"),
    Loader: () => import("@/components/Loader.vue"),
  },
  data: () => ({
    contactError: null,
    role: ["Admin", "Normal"],
    reseller: {
      first_name: null,
      contact: {
        address: null,
        phone: null,
        logo_file_uuid: null,
        state: null,
        email: null,
        city: null,
        zipcode: null,
        country_uuid: null,
      },
      last_name: null,
      companies: [],
    },
    email: null,
    file: null,
    countrys: [],
    allcompanies: [],
    logo_file_uuid: null,
    checkPassword: null,
    loading: true,
  }),
  async created() {
    await this.getCompanyList();
    this.getCountryList();
    this.getReseler();
  },
  methods: {
    handleFirstName(v) {
      this.reseller.first_name = this.$capitalize(v);
    },
    handleLastName(v) {
      this.reseller.last_name = this.$capitalize(v);
    },
    getReseler() {
      this.loading = true;
      this.$store.dispatch("GetReseller", this.$route.params.id).then((res) => {
        this.email = res.contact.email;
        this.checkPassword = res.contact.passwd;
        this.logo_file_uuid = res.contact.logo_file_uuid;
        this.reseller = this.transformReseller(res, 0);
        console.log("res from GetReseller--->", this.reseller);
        this.GetFile();
        this.loading = false;
      }).catch(err => {
        this.$error(err);
        this.loading = false;
      });
    },
    transformReseller(i, k) {
      return {
        first_name: i.first_name,
        contact: {
          address: i.contact.address,
          passwd: i.contact.passwd,
          phone: i.contact.phone,
          logo_file_uuid: i.contact.logo_file_uuid,
          state: i.contact.state,
          email: i.contact.email,
          city: i.contact.city,
          zipcode: i.contact.zipcode,
          country_uuid: i.contact.country_uuid,
        },
        last_name: i.last_name,
        companies: i.companies,
      };
    },
    async getCompanyList() {
      const { total } = await this.$store.dispatch("GetOwnCompanyList", {});

      const res = await this.$store.dispatch("GetOwnCompanyList", {
        perPage: total,
      });
      this.allcompanies = res.items.map((item) => {
        return { name: item.company_name, company_uuid: item.company_uuid };
      });
    },
    getCountryList() {
      this.$store.dispatch("getCountryList", {}).then((res) => {
        this.countrys = res.items;
      });
    },
    GetFile() {
      if (this.reseller.contact.logo_file_uuid) {
        console.log(
          "this.contact.logo_file_uuid",
          this.$refs.userEditDropzone.$el.dropzone
        );
        // this.file = `http://88.198.219.62/api_smsc/v1/file/${this.company.contact.logo_file_uuid}`;
        var mockFile = { size: 1024, name: "Userlogo", type: "image/png" };
        this.$refs.userEditDropzone.$el.dropzone.emit("addedfile", mockFile);
        this.$refs.userEditDropzone.$el.dropzone.emit(
          "thumbnail",
          mockFile,
          `http://88.198.219.62/api_smsc/v1/file/${this.reseller.contact.logo_file_uuid}`
        );
        this.$refs.userEditDropzone.$el.dropzone.emit("complete", mockFile);
      }
    },
    // fileAdded(file) {
    //   console.log(file);
    //   if (file.accepted) {
    //     this.file = file;
    //   }
    // },
    // fileRemoved() {
    //   this.file = null;
    //   this.reseller.contact.logo_file_uuid = null;
    // },
    // uploadPhoto: async function () {
    //   let data = new FormData();

    //   data.append("file", this.file);
    //   data.append("belongs_to", "user.logo");
    //   data.append("public", true);

    //   return await this.$store.dispatch("UploadFile", data);
    // },
    editReseller: async function () {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }

      try {
        //this.reseller.companies = this.reseller.companies.map(i => {return { company_uuid : i.id }})
        if (this.checkPassword == this.reseller.contact.passwd) {
          delete this.reseller.contact.passwd;
        }

        if (this.email == this.reseller.contact.email) {
          delete this.reseller.contact.email;
        }

        // if (this.file) {
        //   const res = await this.uploadPhoto();

        //   this.reseller.contact.logo_file_uuid = res.object_uuid;
        // }

        this.reseller.companies = this.reseller.companies.map((i) => {
          return { company_uuid: i.company_uuid };
        });
        console.log("this.reseller.companies", this.reseller.companies);

        console.log("this.reseller", this.reseller);
        await this.$store.dispatch("EditReseller", {
          reseller_uuid: this.$route.params.id,
          reseller: this.reseller,
        });

        this.$snotify.success("Reseller have been edited.", {
          timeout: 6000,
        });

        this.$router.push({ name: "system-admin-resellers" });
      } catch (err) {
        if (err.errors) {
          this.contactError = err.errors[0].contact
            ? err.errors[0].contact
            : null;
          setTimeout(() => {
            this.contactError = null;
          }, 6000);
        } else if (err.response) {
          this.$snotify.error(
            err.response.data.errors
              ? err.response.data.errors
              : err.response.data.error.message,
            { timeout: 6000 }
          );
        } else {
          this.$snotify.error(err, { timeout: 6000 });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.help {
  margin: 15px 0 15px 0;
}
.row .help:last-child {
  margin-left: 15px;
}
.app-container {
  font-family: "Helvetica Neue";
  padding: 0 20px;

  .header {
    font-size: 16px;
    color: #666;
  }
  .add-navigation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
    .back-link {
      cursor: pointer;
      display: flex;
      align-items: center;
      fill: #51a3f3;
      color: #51a3f3;
      font-family: "Helvetica Neue";
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      p {
        margin: 0;
      }
    }
    .buttons-wrapper {
      display: flex;
      align-items: center;
      width: fit-content;
      .primary-button {
        height: 40px;
        width: 145px;
      }
      .secondary-button {
        height: 40px;
        width: 90px;
        margin-right: 20px;
      }
    }
  }
  .add-container {
    flex-direction: column;
    align-items: center;
    height: auto;
    background-color: #ffffff;
    .container-title {
      color: #000000;
      font-size: 16px;
      font-weight: 500;
    }
    .col-wrapper {
      width: 100%;
      margin-left: 15px;
      margin-top: 20px;
      .col {
        float: left;
        .row {
          width: 100%;
          flex-wrap: nowrap;
          .input {
            padding-right: 15px;
          }
          .last {
            padding-right: 0;
          }
          .multiselect {
            width: 100%;
            // margin-right: 15px;
          }
          .row-first {
            width: 33.333%;
          }
          .row-second {
            width: 33.333%;
          }
          .row-address {
            width: 70%;
          }
          .row-zipcode {
            width: 30%;
          }
          .row-country {
            width: 50%;
          }
          .row-third {
            width: 25%;
          }
        }
        .input {
          margin-bottom: 20px;
        }
        .field {
          p.pimary-input-title {
            color: #000000;
            font-family: "Helvetica Neue";
            font-size: 12px;
            font-weight: 900;
          }
        }
        .dimension,
        #editdropzone {
          min-height: 90px;
          height: 90px;
          width: 90px;
          border-radius: 45px;
          .dz-preview,
          .dz-processing,
          .dz-image-preview,
          .dz-success,
          .dz-complete,
          .dz-complete {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-left: -40px;
            min-height: 80px;
            top: -20px;
          }
          .dz-image {
            padding: 5px;
            img {
              height: 80px;
              width: 80px;
              border-radius: 50px;
            }
          }
          .dz-details {
            height: 80px;
            width: 80px;
            border-radius: 50px;
            .dz-size {
              padding-top: 15px;
              span {
                font-size: 14px;
              }
            }
          }
          a {
            font-size: 10px;
            height: 80px;
            width: 80px;
            border-radius: 50px;
            margin-top: 20px;
            margin-left: 0px;
          }
        }
        .upload-photo,
        #dropzone {
          min-height: 285px;
          min-height: 285px;
          border-radius: 4px;
          width: 100%;
          .dz-image {
            padding: 5px;
            img {
              height: 150px;
              width: 150px;
              border-radius: 50px;
            }
          }
        }
        .pimary-input-title {
          color: #000000;
          font-family: "Helvetica Neue";
          font-size: 12px;
          font-weight: 900;
          letter-spacing: 0.21px;
          line-height: 15px;
          margin-bottom: 5px;
          text-transform: uppercase;
        }
        .upload-contaioner {
          border: 1px solid #5171f3;
          border-radius: 4px;
          background-color: #ffffff;
          height: 265px;
          border-style: dashed;
          margin-right: 15px;
          position: relative;
          input[type="file"] {
            position: absolute;
            height: 36px;
            width: 136px;
            opacity: 0;
            cursor: pointer;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%); /* IE 9 fix */
            z-index: 1;
          }
          .upload-button {
            height: 36px;
            width: 136px;
            border-radius: 4px;
            background-color: #51a3f3;
            margin: 0;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
      }
      .upload-col {
        width: 30%;
        padding-right: 15px;
        padding-left: 0;
        float: left;
        .help {
          margin-top: 0;
        }
      }
      .fields-col {
        width: 99%;
        padding-right: 0;
      }
    }
    .email-input {
      margin-bottom: 20px;
    }
    .password-input {
      margin-bottom: 30px;
    }
    .first {
      margin-bottom: 30px;
      .remember-me {
        display: flex;
        align-items: center;
        input {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
  .button_size{
   min-width: 145px;
    margin-left: 0px!important;
  }
  @media (max-width: 585px) {
    .button-margin-size{
      margin-top: 16px;
    }
  }
</style>
